<template>
  <div id="about">
    <v-sheet id="privacy">
      <v-layout
        column
        justify-center
        class="pt-16 text-justify ml-lg-16 mr-lg-16 pl-lg-16 pr-lg-16 ml-5 mr-5"
      >
        <h1 class="neutral--text mb-5">
          Privacy Policy and Terms and Conditions
        </h1>
        <p class="neutral700--text pb-6">
          Discover our Privacy Policy, Cookies Policy and Terms and Conditions by visiting the links
          below. Your privacy is important to us.
        </p>
        <p>
          <PrivacyPolicyModal />
        </p>
        <p>
          <CookiesPolicyModal />
        </p>
        <p>
          <TermsAndConditionsModal />
        </p>
      </v-layout>
    </v-sheet>
  </div>
</template>

<script>
import CookiesPolicyModal from '@/components/landing-page/policies/CookiesPolicyModal.vue';
import TermsAndConditionsModal from '@/components/landing-page/policies/TermsAndConditionsModal.vue';
import PrivacyPolicyModal from '@/components/landing-page/policies/PrivacyPolicyModal.vue';

export default {
  name: 'PrivacyPolicy',
  components: { PrivacyPolicyModal, CookiesPolicyModal, TermsAndConditionsModal },
  methods: {
    downloadFile(file) {
      this.axios({
        url: 'api/v1/files/' + file,
        method: 'GET',
        responseType: 'blob', // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file);
        document.body.appendChild(link);
        link.click();
      });
    },
  },
};
</script>
